import { FunctionComponent } from 'react';
import 'office-ui-fabric-core/dist/css/fabric.min.css'

export const BwjGrid: FunctionComponent = (props) => {
  return (
    <div className="ms-Grid" dir="ltr">
        {props.children}
    </div>
  );
};